<template>
  <div class="expert-item" @click="navToDetail">
    <div class="avatar-box">
      <img :src="data.poster" class="avatar" alt="头像" />
    </div>
    <div class="content-wrap">
      <div class="username">{{ data.name }}</div>
      <div class="title">{{ data.title }}</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "expert-item",
    data() {
      return {};
    },
    props: {
      data: Object,
    },
    created() {},
    mounted() {},
    methods: {
      navToDetail() {
        this.$router.push({
          path: "/expert-detail",
          query: {
            id: this.data.id,
          },
        });
      },
    },
  };
</script>

<style scoped lang="scss">
  .expert-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    cursor: pointer;
    .avatar-box {
      width: 244px;
      height: 324px;
      padding: 10px;
      border: 1px solid #ab9388;
      box-sizing: border-box;
      position: relative;
      &::after {
        content: "";
        width: 30px;
        height: 2px;
        background-color: #ab9388;
        position: absolute;
        top: 4px;
        right: -10px;
        transform-origin: center;
        transform: rotate(45deg);
      }
      &::before {
        content: "";
        width: 30px;
        height: 2px;
        background-color: #ab9388;
        position: absolute;
        bottom: 4px;
        left: -10px;
        transform-origin: center;
        transform: rotate(45deg);
      }
      .avatar {
        width: 100%;
        height: 100%;
        object-fit: cover;
        background-color: #fff;
      }
    }

    .content-wrap {
      background-image: url("../../../../assets/img/bg_expert.png");
      background-size: contain;
      background-repeat: no-repeat;
      width: 249px;
      height: 68px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-direction: column;
      margin: 18px 0 0;
      text-align: center;

      .username {
        width: 100%;
        font-size: 15px;
        font-weight: bold;
        margin: 0 0 10px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      .title {
        width: 100%;
        font-size: 14px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
  }
</style>
